import { useSelector } from 'react-redux';
import { selectUserPreference } from 'redux/UserPreferences';
import { selectUserPreferences } from 'redux/selectors';
import { trimTitle } from 'components/shared/DeviceChart';

function useChartPreference(meta, requestedQuery) {
  const { preferenceId } = meta;
  const preference = useSelector((state) => selectUserPreference(selectUserPreferences(state), preferenceId));
  const { name = '', local = false, state: { query: preferredQuery, datasets, scales } = {} } = preference || {};
  const query = {
    ...preferredQuery,
    ...requestedQuery
  };
  const title = trimTitle(name);

  return { title, query, datasets, scales, isLoaded: preference != null, isLocal: local };
}

export { useChartPreference };
